var React = require('react');

function CircleBMob (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M400.5,716.2A532.12,532.12,0,0,1,213,682.29V800H588V682.29A532.12,532.12,0,0,1,400.5,716.2Z","transform":"translate(-213 -682.29)"}));
}

CircleBMob.defaultProps = {"id":"Layer_1","data-name":"Layer 1","viewBox":"0 0 375 117.71"};

module.exports = CircleBMob;

CircleBMob.default = CircleBMob;
